import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ExchangeEstimateReq, ExchangeEstimateRes, ExchangeReq, ExchangeRes } from '@kr/components/exchange/models';
import { environment } from '@kr/environment';
import { OrganizationService } from '@kr/services';

@Injectable()
export class ExchangeApiService {
  readonly #http = inject(HttpClient);
  readonly #apiHost = environment.apiHost;
  readonly #organizationService = inject(OrganizationService);

  exchange(req: ExchangeReq, orgId: number): Observable<ExchangeRes> {
    return this.#http.post<ExchangeRes>(`${this.#apiHost}/transactions/exchange/create/`, req, {
      headers: this.#organizationService.getHttpHeaders(orgId),
    });
  }

  exchangeEstimate(req: ExchangeEstimateReq, orgId: number): Observable<ExchangeEstimateRes> {
    return this.#http.post<ExchangeEstimateRes>(`${this.#apiHost}/transactions/exchange/estimates/`, req, {
      headers: this.#organizationService.getHttpHeaders(orgId),
    });
  }
}
